function ideaCardsCarousel() {
	var owl1 = $(".index-ideaCards .owlCarousel");
	owl1.owlCarousel({
		loop:false,
		responsive:{
			0:{items:1},
			640:{items:2},
			1024:{items:3},
			1800:{items:4},
		},
		autoplay: true,
		autoplayTimeout: 5000,
		autoplayHoverPause: true,
		loop: false,
		onTranslate: hidingTooltipsOnScroll
	});
	$(".index-ideaCards .right").click(function() {
		owl1.trigger('next.owl.carousel');
	});
	$(".index-ideaCards .left").click(function() {
		owl1.trigger("prev.owl.carousel");
	});
}